import {
    FETCH_OFFERING_ERROR,
    FETCH_OFFERING_REQUEST,
    GET_OFFERINGS,
    GET_SELECTED_OFFERING,
    GET_SELECTED_OFFERING_PARTNER,
    IS_OFFERING_PARTNER_SELECTED,
    IS_OFFERING_SELECTED,
} from '../ActionTypes';

const initialState = {
    availableOfferings: [],
    partnerOfferings: [],
    loading: true,
    error: '',
    selectedOffering: '',
    selectedPartner: '',
    isPartnerSelected: true,
    isOfferingSelected: true,
    emptyOfferingForm: {},
};

const offeringReduction = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_OFFERING_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_OFFERING_ERROR:
            return {
                ...state,
                selectedOfferings: [],
                loading: false,
                error: action.payload,
            };
        case GET_OFFERINGS:
            return {
                ...state,
                availableOfferings: action.payload,
            };
        case GET_SELECTED_OFFERING:
            return {
                ...state,
                selectedOffering: action.payload,
            };
        case GET_SELECTED_OFFERING_PARTNER:
            return {
                ...state,
                selectedPartner: action.payload,
            };
        case IS_OFFERING_SELECTED:
            return {
                ...state,
                isOfferingSelected: action.payload,
            };
        case IS_OFFERING_PARTNER_SELECTED:
            return {
                ...state,
                isPartnerSelected: action.payload,
            };
        default:
            return state;
    }
};

export default offeringReduction;
